import { dateConverter, timeConverter } from "../../helpers/functions";

export const TYPE_VALUES = { INCOME: 1, EXPENSE: 2, 1: "Income", 2: "Expense" };

const generatePrintContent = (data) => {
  const logoUrl = `${window.location.origin}/logo.png`;
  return `
  <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; max-width: 100%; color: #333; line-height: 1.5; padding: 10px;">
    
    <!-- Brand Header -->
    <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 3px solid #1e3d59; padding-bottom: 15px; margin-bottom: 20px;">
      <div style="display: flex; align-items: center; gap: 15px;">
        <img src="${logoUrl}" alt="Sea Tech Marine Logo" style="height: 65px; width: auto; object-fit: contain;" />
        <div>
          <h1 style="font-size: 24px; font-weight: 700; color: #1e3d59; margin: 0; letter-spacing: 0.5px;">Sea Tech Marine</h1>
          <span style="font-size: 11px; color: #7f8c8d; font-weight: 600; letter-spacing: 1px;">Service Management</span>
        </div>
      </div>
      <div style="text-align: right;">
        <h2 style="font-size: 18px; font-weight: 700; color: #1e3d59; margin: 0; letter-spacing: 0.5px;">Payment Details</h2>
        <p style="font-size: 12px; color: #7f8c8d; margin: 5px 0 0 0; font-weight: 500;">
          Date: <span style="color: #333; font-weight: 600;">${dateConverter(data.date)}</span> &nbsp;|&nbsp; 
          Time: <span style="color: #333; font-weight: 600;">${timeConverter(data.time)}</span>
        </p>
      </div>
    </div>

    <!-- Info Cards Grid -->
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
      <tr>
        <td style="width: 50%; padding-right: 10px; vertical-align: top;">
          <div style="background-color: #f8f9fa; border: 1px solid #dee2e6; border-radius: 6px; padding: 15px; min-height: 120px;">
            <h3 style="font-size: 12px; color: #1e3d59; border-bottom: 1px solid #dee2e6; padding-bottom: 8px; margin-top: 0; margin-bottom: 10px; font-weight: 700; letter-spacing: 0.5px;">Customer Details</h3>
            <table style="width: 100%; font-size: 13px; border-collapse: collapse;">
              <tr>
                <td style="padding: 3px 0; color: #6c757d; width: 70px; font-weight: 500;">Name:</td>
                <td style="padding: 3px 0; color: #212529; font-weight: 600;">${data.name || "-"}</td>
              </tr>
              <tr>
                <td style="padding: 3px 0; color: #6c757d; font-weight: 500;">Mobile:</td>
                <td style="padding: 3px 0; color: #212529; font-weight: 600;">${data.mobile || "-"}</td>
              </tr>
              <tr>
                <td style="padding: 3px 0; color: #6c757d; font-weight: 500;">Boat:</td>
                <td style="padding: 3px 0; color: #212529; font-weight: 600;">${data.boat || "-"}</td>
              </tr>
            </table>
          </div>
        </td>
        <td style="width: 50%; padding-left: 10px; vertical-align: top;">
          <div style="background-color: #f8f9fa; border: 1px solid #dee2e6; border-radius: 6px; padding: 15px; min-height: 120px;">
            <h3 style="font-size: 12px; color: #1e3d59; border-bottom: 1px solid #dee2e6; padding-bottom: 8px; margin-top: 0; margin-bottom: 10px; font-weight: 700; letter-spacing: 0.5px;">Payment Summary</h3>
            <table style="width: 100%; font-size: 13px; border-collapse: collapse;">
              <tr>
                <td style="padding: 3px 0; color: #6c757d; width: 100px; font-weight: 500;">Total Amount:</td>
                <td style="padding: 3px 0; color: #212529; font-weight: 600;">${Number(data.amount || 0).toFixed(2)}</td>
              </tr>
              <tr>
                <td style="padding: 3px 0; color: #6c757d; font-weight: 500;">Due Amount:</td>
                <td style="padding: 3px 0; color: #dc3545; font-weight: 700;">${Number(data.dueAmount || 0).toFixed(2)}</td>
              </tr>
              <tr>
                <td style="padding: 3px 0; color: #6c757d; font-weight: 500;">Status:</td>
                <td style="padding: 3px 0;">
                  <span style="display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 11px; font-weight: 700; ${Number(data.dueAmount || 0) <= 0 ? 'background-color: #d1fae5; color: #065f46;' : 'background-color: #fee2e2; color: #991b1b;'}">
                    ${Number(data.dueAmount || 0) <= 0 ? 'Paid' : 'Pending Due'}
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
    </table>

    <!-- Description / Remarks -->
    ${
      data.remarks
        ? `
      <div style="margin-bottom: 20px; background-color: #f8f9fa; border-left: 4px solid #1e3d59; padding: 12px 15px; border-radius: 0 6px 6px 0; border-top: 1px solid #dee2e6; border-right: 1px solid #dee2e6; border-bottom: 1px solid #dee2e6;">
        <span style="font-size: 11px; color: #6c757d; display: block; font-weight: 700; letter-spacing: 0.5px; margin-bottom: 5px;">Description / Remarks</span>
        <p style="margin: 0; font-size: 13px; color: #333; line-height: 1.5; white-space: pre-wrap;">${data.remarks}</p>
      </div>
    `
        : ""
    }

    <!-- Spare Parts & Services Table -->
    ${
      data.parts?.length
        ? `
      <div style="margin-bottom: 25px;">
        <h3 style="font-size: 13px; color: #1e3d59; margin-bottom: 10px; font-weight: 700; letter-spacing: 0.5px;">Spare Parts & Services</h3>
        <div style="border: 1px solid #dee2e6; border-radius: 6px; overflow: hidden;">
          <table style="width: 100%; border-collapse: collapse; font-size: 13px; text-align: left;">
            <thead>
              <tr style="background-color: #1e3d59; color: white;">
                <th style="padding: 10px 12px; font-weight: 600; width: 6%; text-align: center; border: none;">#</th>
                <th style="padding: 10px 12px; font-weight: 600; width: 44%; border: none;">Part / Service Description</th>
                <th style="padding: 10px 12px; font-weight: 600; width: 16%; text-align: right; border: none;">Unit Price</th>
                <th style="padding: 10px 12px; font-weight: 600; width: 14%; text-align: center; border: none;">Qty</th>
                <th style="padding: 10px 12px; font-weight: 600; width: 20%; text-align: right; border: none;">Total</th>
              </tr>
            </thead>
            <tbody>
              ${data.parts
                .map((part, index) => {
                  if (!part.part) return "";
                  return `
                  <tr style="border-bottom: 1px solid #dee2e6; background-color: ${index % 2 === 0 ? "#ffffff" : "#f8f9fa"};">
                    <td style="padding: 10px 12px; color: #6c757d; text-align: center;">${index + 1}</td>
                    <td style="padding: 10px 12px; color: #212529; font-weight: 500;">${part.part}</td>
                    <td style="padding: 10px 12px; text-align: right; color: #212529;">${Number(part.amount || 0).toFixed(2)}</td>
                    <td style="padding: 10px 12px; text-align: center; color: #212529;">${part.quantity}</td>
                    <td style="padding: 10px 12px; text-align: right; color: #212529; font-weight: 600;">${Number(part.total || 0).toFixed(2)}</td>
                  </tr>
                  `;
                })
                .join("")}
              
              <!-- Pricing Breakdown -->
              <tr style="background-color: #ffffff;">
                <td colspan="2" style="border: none;"></td>
                <td colspan="2" style="padding: 12px 10px 4px 10px; text-align: right; color: #6c757d; font-weight: 600; font-size: 12px; border: none; white-space: nowrap;">Subtotal:</td>
                <td style="padding: 12px 12px 4px 10px; text-align: right; color: #212529; font-weight: 600; border: none;">
                  ${data.parts.reduce((sum, p) => sum + Number(p.total || 0), 0).toFixed(2)}
                </td>
              </tr>
              
              ${
                data.labourCharge
                  ? `
              <tr style="background-color: #ffffff;">
                <td colspan="2" style="border: none;"></td>
                <td colspan="2" style="padding: 4px 10px; text-align: right; color: #6c757d; font-weight: 600; font-size: 12px; border: none; white-space: nowrap;">Labour Charge:</td>
                <td style="padding: 4px 12px; text-align: right; color: #0d6efd; font-weight: 600; border: none;">
                  +${Number(data.labourCharge).toFixed(2)}
                </td>
              </tr>
              `
                  : ""
              }
              
              ${
                data.discount
                  ? `
              <tr style="background-color: #ffffff;">
                <td colspan="2" style="border: none;"></td>
                <td colspan="2" style="padding: 4px 10px; text-align: right; color: #6c757d; font-weight: 600; font-size: 12px; border: none; white-space: nowrap;">Discount:</td>
                <td style="padding: 4px 12px; text-align: right; color: #dc3545; font-weight: 600; border: none;">
                  -${Number(data.discount).toFixed(2)}
                </td>
              </tr>
              `
                  : ""
              }
              
              <tr style="background-color: #ffffff; border-top: 1px solid #dee2e6;">
                <td colspan="2" style="border: none;"></td>
                <td colspan="2" style="padding: 10px 10px 12px 10px; text-align: right; color: #1e3d59; font-weight: 700; font-size: 14px; border: none; white-space: nowrap;">Total Amount:</td>
                <td style="padding: 10px 12px 12px 10px; text-align: right; color: #198754; font-weight: 700; font-size: 14px; border: none;">
                  ${Number(data.amount || 0).toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    `
        : ""
    }

    <!-- Payment History -->
    ${
      data.payments?.length > 0
        ? `
      <div style="margin-bottom: 30px;">
        <h3 style="font-size: 13px; color: #1e3d59; margin-bottom: 10px; font-weight: 700; letter-spacing: 0.5px;">Payment History</h3>
        <div style="border: 1px solid #dee2e6; border-radius: 6px; overflow: hidden;">
          <table style="width: 100%; border-collapse: collapse; font-size: 12px; text-align: left;">
            <thead>
              <tr style="background-color: #f8f9fa; border-bottom: 1px solid #dee2e6;">
                <th style="padding: 8px 15px; color: #6c757d; font-weight: 700; width: 60%; border: none;">Payment Date & Time</th>
                <th style="padding: 8px 15px; color: #6c757d; font-weight: 700; width: 40%; text-align: right; border: none;">Amount Paid</th>
              </tr>
            </thead>
            <tbody>
              ${data.payments
                .map(
                  (payment) => `
                <tr style="border-bottom: 1px solid #dee2e6; background-color: #ffffff;">
                  <td style="padding: 8px 15px; color: #333;">
                    ${dateConverter(payment.date)} at ${timeConverter(payment.time)}
                  </td>
                  <td style="padding: 8px 15px; text-align: right; color: #198754; font-weight: 600;">
                    ${Number(payment.amount).toFixed(2)}
                  </td>
                </tr>
              `
                )
                .join("")}
            </tbody>
          </table>
        </div>
      </div>
    `
        : ""
    }

    <!-- Footer -->
    <div style="margin-top: 40px; text-align: center; border-top: 1px solid #dee2e6; padding-top: 20px;">
      <p style="font-size: 13px; color: #1e3d59; font-weight: 700; margin: 0; letter-spacing: 0.5px;">Thank you for your business!</p>
      <p style="font-size: 11px; color: #7f8c8d; margin: 5px 0 0 0;">If you have any questions concerning this payment receipt, please contact us.</p>
    </div>

  </div>
  `;
};

const shareWithAlternativeMethod = async (htmlContent, data) => {
  const { default: html2canvas } = await import("html2canvas");
  const { PDFDocument } = await import("pdf-lib");

  const tempDiv = document.createElement("div");
  // Object.assign(tempDiv.style, {
  //   position: "fixed",
  //   left: "-9999px",
  //   top: "0",
  //   width: "210mm",
  //   height: "297mm",
  //   overflow: "hidden",
  //   visibility: "hidden",
  //   opacity: "0",
  //   pointerEvents: "none",
  //   zIndex: "-1",
  // });
  tempDiv.style.position = "fixed";
  tempDiv.style.left = "0";
  tempDiv.style.top = "0";
  tempDiv.style.width = "210mm";
  tempDiv.style.padding = "20px";
  tempDiv.style.background = "white";
  tempDiv.style.zIndex = "-1";
  tempDiv.innerHTML = htmlContent;
  document.body.appendChild(tempDiv);

  try {
    const canvas = await html2canvas(tempDiv, {
      scale: 3,
      logging: false,
      useCORS: true,
      allowTaint: true,
      windowWidth: tempDiv.scrollWidth,
      windowHeight: tempDiv.scrollHeight,
    });

    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([595.28, 841.89]);

    const pngImage = await pdfDoc.embedPng(canvas.toDataURL("image/png", 1.0));
    const scale = Math.min(page.getWidth() / canvas.width, page.getHeight() / canvas.height);

    page.drawImage(pngImage, {
      x: 0,
      y: page.getHeight() - canvas.height * scale,
      width: canvas.width * scale,
      height: canvas.height * scale,
    });

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const fileName = `payment_${data.boat || data.name || "Receipt"}.pdf`;

    if (navigator.share && navigator.canShare({ files: [new File([blob], fileName)] })) {
      await navigator.share({
        title: "Payment Receipt",
        files: [new File([blob], fileName, { type: "application/pdf" })],
      });
    } else {
      const pdfUrl = URL.createObjectURL(blob);
      const newWindow = window.open(pdfUrl, "_blank");

      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
        if (newWindow && !newWindow.closed) {
          newWindow.focus();
        }
      }, 3000);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  } finally {
    document.body.removeChild(tempDiv);
  }
};

export const handlePrint = async (data) => {
  try {
    window.dispatchEvent(new CustomEvent("show-print-loader", { detail: true }));
    
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "1px";
    iframe.style.height = "1px";
    iframe.style.left = "-9999px";
    iframe.style.top = "-9999px";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const printContent = `
      <html lang="en">
    <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Payment Details - ${data.boat || data.name || ""}</title>
    <style>
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
      }
      
      body {
        padding: 20px;
        color: #333;
        background: white;
      }

      @media print {
        @page {
          margin: 10mm;
          size: A4;
        }
        
        body {
          padding: 0;
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
          print-color-adjust: exact !important;
          background: white !important;
        }
        
        * {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
      }
    </style>
  </head>
  <body>
        ${generatePrintContent(data)} 
      </body>
      </html>
    `;
    await shareWithAlternativeMethod(printContent, data);
  } catch (error) {
    console.error("Error in handlePrint:", error);
  } finally {
    window.dispatchEvent(new CustomEvent("show-print-loader", { detail: false }));
  }
};
